import React, {useContext} from 'react';
import { useTranslation } from 'react-i18next';
import { NavDropdown } from "react-bootstrap";
import { NavLink } from 'react-router-dom';
import config from '../../config';
import Deadline from './Deadline';
import i18n from '../../i18n';
import LocaleContext from '../../LocaleContext';

var url = config.nav.url;

var login_link = url+'login';
var dashboard_link = url+'dashboard';
var admin_link = url + 'admin';
var register_link = url+'register';
var logout_link=url+'logout';

const Navbar1 = (props) => {
    const { t } = useTranslation();
    const { locale } = useContext(LocaleContext);

    function changeLocale (l) {
        if (locale !== l) {
          i18n.changeLanguage(l);
        }
    }
    const type = localStorage.getItem('type');
    const displayName = localStorage.getItem('displayName') !== 'undefined' ? localStorage.getItem('displayName') : '';

    return (
        <div>
            <nav className="navbar navbar-expand-lg navbar-light bg-light form ">
                <div className="container">
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                        <li className="nav-item">
                            <NavLink to={url} className="text-white fs-3 deco_null">APAFReP</NavLink>
                        </li>
                    </ul>
                    <Deadline/>
                    {props.auth?
                    <>
                    <NavLink to={login_link} className="btn btn-primary ms-auto px-4 rounded-pill">
                        <i className="fa fa-sign-in me-2"></i>Se connecter</NavLink>
                    <NavLink to={register_link} className="btn btn-primary ms-2 px-4 rounded-pill">
                        <i className="fa fa-user-plus me-2"></i>Créer un compte</NavLink>
                        </>
                        :
                        <>
                    {
                        type !== 'admin'  && type !== 'exam' ?
                        <p className="ms-2 px-4 mt-3 text-white"><a href={dashboard_link} className='deco_null text-white'>{t('welcome')} {displayName}</a></p>
                        :
                        <p className="ms-2 px-4 mt-3 text-white">{t('welcome')} {displayName}</p>
                    }
                    {
                        type === 'admin' || type === 'exam'  ?
                        <NavLink to={admin_link} className="ms-2 px-4 text-white deco_null">
                        <i className="fa fa-dashboard me-2"></i>Administration</NavLink>
                        : <></>

                    }
                    <NavLink to={logout_link} className="ms-2 px-4 text-white deco_null">
                        <i className="fa fa-sign-out me-2"></i>{t('logout')}</NavLink>
                        </>
                    }
                    <NavDropdown className='strong-black' title={t('language')} id="basic-nav-dropdown-white">
                                <NavDropdown.Item href="#" onClick={() => changeLocale('fr')}>Français</NavDropdown.Item>
                                <NavDropdown.Item href="#" onClick={() => changeLocale('en')}>English</NavDropdown.Item>
                        </NavDropdown>
                    </div>
                </div>
            </nav>
        </div>
    );
}

export default Navbar1;